module.exports = __webpack_public_path__ + "62706064fb716c4f204ea761e59c22bb.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/ribbons/letters/4.png
// module id = 2946
// module chunks = 0